import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreTypes } from '../storeTypes.enum';
import { ComputersStatisticState } from './state';

export const selectComputersStatisticFeatureState = createFeatureSelector<ComputersStatisticState>(StoreTypes.ComputersStatistic);

export const selectStatisticLoading = createSelector(selectComputersStatisticFeatureState, (state) => state.statisticLoading);
export const selectStatisticLoaded = createSelector(selectComputersStatisticFeatureState, (state) => state.statisticLoaded);

export const selectStatistic = createSelector(selectComputersStatisticFeatureState, (state) => state.statistic);

export const selectOneComputerExist = createSelector(selectComputersStatisticFeatureState, (state) => state.oneComputerExist);
export const selectOneComputerLoading = createSelector(selectComputersStatisticFeatureState, (state) => state.oneComputerExistLoading);
export const selectOneComputerLoaded = createSelector(selectComputersStatisticFeatureState, (state) => state.oneComputerExistLoaded);

// combined
export const selectOneComputerExistLoaded = createSelector(
  selectOneComputerExist,
  selectOneComputerLoaded,
  (exist, loaded) => exist && loaded
);
